<template>
  <header class="index-page-panel__head">
    <div class="index-page-panel__titles">
      <p v-if="moduleLabel" class="index-page-panel__crumb">
        {{ moduleLabel }}
        <span>/</span>
        {{ sectionLabel }}
      </p>
      <h1 class="index-page-panel__title">
        {{ title }}
      </h1>
      <p v-if="countLabel" class="index-page-panel__subtitle">
        <span class="index-page-panel__total">{{ countLabel }}</span>
        <slot name="subtitle-extra" />
      </p>
      <slot name="subtitle" />
    </div>
    <div class="index-page-panel__head-actions">
      <slot name="actions" />
    </div>
  </header>
</template>

<script setup>
defineProps({
  moduleLabel: { type: String, default: '' },
  sectionLabel: { type: String, default: 'Directory' },
  title: { type: String, default: '' },
  /** e.g. "1366 companies" or "24 records" */
  countLabel: { type: String, default: '' },
})
</script>

<style src="../styles/index-page-panel.scss"></style>
